"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductViewLoadEvent = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var getProductViewLoadEvent = function (event) {
    var _a, _b, _c, _d, _e;
    var eventInfo = (event === null || event === void 0 ? void 0 : event.eventName) === analytics_layer_1.ProductViewLoadEventNames.FreeProductViewLoad || ((_a = event === null || event === void 0 ? void 0 : event.eventData) === null || _a === void 0 ? void 0 : _a.isFree)
        ? analytics_layer_1.ProductViewLoadEventNames.FreeProductViewLoad
        : analytics_layer_1.ProductViewLoadEventNames.ProductViewLoad;
    var action = eventInfo === analytics_layer_1.ProductViewLoadEventNames.FreeProductViewLoad ? 'free-prod-view' : 'prod-view';
    var eventData = {
        action: action,
        event: eventInfo,
        eventInfo: eventInfo,
        cart: __assign({ product: (_c = (_b = event === null || event === void 0 ? void 0 : event.eventData) === null || _b === void 0 ? void 0 : _b.cart) === null || _c === void 0 ? void 0 : _c.product }, (action === 'prod-view' && {
            checkoutType: ((_e = (_d = event === null || event === void 0 ? void 0 : event.eventData) === null || _d === void 0 ? void 0 : _d.cart) === null || _e === void 0 ? void 0 : _e.checkoutType) || consts_1.DEFAULT_CHECKOUT_TYPE,
        })),
    };
    return eventData;
};
exports.getProductViewLoadEvent = getProductViewLoadEvent;
